// @flow
import type { Styles } from './types';

const styles: Styles = theme => ({
  root: {},
  wrapper: {
    width: '100%',
    maxWidth: 600,
    padding: theme.spacing(1),
  },
  items: {},
  chip: {
    margin: theme.spacing(1),
  },
  cleanButton: {
    width: '100%',
  },
});

export default styles;
